import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLoaderData } from "react-router";
import { HomeData } from "../App.tsx";
import { useAuth } from "../components/auth/ParseAuthContext";
import { StartPage } from "../components/home/StartPage.tsx";
import { getUserDisplayName } from "../shared/userDisplayName.ts";

const Home = () => {
  const { cases, overview } = useLoaderData<HomeData>();
  const { auth } = useAuth();
  const { t } = useTranslation();

  // one of the testimonials, another at every visit
  const [quote] = useState(() => {
    const quotes = t("login.quotes", { returnObjects: true }) as {
      text: string;
      author: string;
    }[];
    return quotes[Math.floor(Math.random() * quotes.length)];
  });

  return (
    <StartPage
      cases={cases}
      overview={overview}
      userName={
        auth.kind === "signedIn" ? getUserDisplayName(auth.user) : undefined
      }
      quote={quote}
    />
  );
};

export default Home;
